// src/pages/Home.jsx
import React from 'react';
import BlogList from '../components/BlogList';

const Home = () => {
  return (
    <div className="home-page">
      <BlogList />
    </div>
  );
};

export default Home;